import { useEffect, useState } from "react";

const RACE_DATA_IMAGES_BASE =
  "https://race-data-api.escapecollective.com/images/riders";
const FC_RIDER_IMG_PATTERN =
  /^https?:\/\/(?:www\.)?firstcycling\.com\/img\/rider\/(\d{4})\/(\d+)\/?$/;
const SILHOUETTE = "/img/silhouette.png";

// FC blocks hotlinking, so rewrite its URLs to our race-data-api cache.
// The cache serves .png for most riders but .jpg for some, and doesn't
// cover every rider, so each candidate falls through to the next on error.
export function riderImageSources(photoUrl) {
  if (!photoUrl) return [SILHOUETTE];

  const fcMatch = photoUrl.match(FC_RIDER_IMG_PATTERN);
  if (fcMatch) {
    const [, year, fcId] = fcMatch;
    return [
      `${RACE_DATA_IMAGES_BASE}/${year}/${fcId}.png`,
      `${RACE_DATA_IMAGES_BASE}/${year}/${fcId}.jpg`,
      SILHOUETTE,
    ];
  }

  return [photoUrl, SILHOUETTE];
}

export function RiderImage({ photoUrl, ...props }) {
  const sources = riderImageSources(photoUrl);
  const [sourceIndex, setSourceIndex] = useState(0);

  useEffect(() => {
    setSourceIndex(0);
  }, [photoUrl]);

  const src = sources[Math.min(sourceIndex, sources.length - 1)];

  return (
    <img
      src={src}
      onError={() =>
        setSourceIndex((index) => Math.min(index + 1, sources.length - 1))
      }
      {...props}
    />
  );
}

export function GridHeadshot({ player, silhouette }) {
  const silhouetteStyle = silhouette ? "opacity-80 contrast-0" : "";

  return (
    <RiderImage
      photoUrl={player.photo_url}
      className={`w-full ${silhouetteStyle}`}
    />
  );
}

export function ChampionHeadshot({ player, ...props }) {
  return (
    <img
      src={`https://s.afl.com.au/staticfile/AFL%20Tenant/AFL/Players/ChampIDImages/AFL/${player.last}014/${player.c}.png`}
      {...props}
    />
  );
}

export function LocalHeadshot({ player, ...props }) {
  return (
    <img
      src={`/img/headshots/${player.id}-${player.name
        .replaceAll(" ", "-")
        .toLowerCase()}.png`}
      {...props}
    />
  );
}
